







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { HorizontalAlignment, TwoPlusOneBlocksViewModel } from '@/types/contentServerContract';
import ContentBlockContainer from '@/project/app/blocks/ContentBlockContainer.vue';

@Component({
    components: { ContentBlockContainer }
})
export default class OnePlusTwoBlocks extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: TwoPlusOneBlocksViewModel;

    @Prop(String) alias!: string;

    @Prop({ required: true, type: Boolean })
    isFirstBlock!: boolean;

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    get blockAlignmentRight() {
        return this.content.largeBlockAlignmentValue !== HorizontalAlignment.Left;
    }

    get largeBlock() {
        return (this.content?.largeBlock?.length > 0 && this.content.largeBlock[0]) || null;
    }

    get halfWidthBlocksOne() {
        return (this.content?.halfWidthBlocks?.length > 0 && this.content.halfWidthBlocks[0]) || null;
    }

    get halfWidthBlocksTwo() {
        return (this.content?.halfWidthBlocks?.length > 1 && this.content.halfWidthBlocks[1]) || null;
    }
}
